import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { HashRouter as Router, Route, Switch } from 'react-router-dom'
import './style.css'

// ======================= Импорты страниц =======================
import Uzhzhatlar from './views/uzhzhatlar'
import Arizalarnikribchiishmuddati from './views/arizalarni-krib-chiish-muddati'
import Submissioncollection from './views/submission-collection'

import KyrgyzstanGermanyUz from './views/kyrgyzstan-germanyuz'
import KyrgyzstanCzech from './views/kyrgyzstan-chex'

import Tegishlimalumotlar from './views/tegishli-malumotlar'
import Arizatopshirishuchunsrovnomatldirish from './views/ariza-topshirish-uchun-srovnoma-tldirish'
import Vipkhizmati from './views/vip-khizmati'
import Visametricgurukhi from './views/visametric-gurukhi'
import Shimchakhizmatlar from './views/shimcha-khizmatlar'
import Contact from './views/contact'
import Home from './views/home'
import Callcenter from './views/callcenter'
import Office from './views/office'
import Kerakliuzhzhatlar from './views/kerakli-uzhzhatlar'
import Arizatopshirishzharaeni from './views/ariza-topshirish-zharaeni'
import Onlaynsrovnomasi from './views/onlayn-srovnomasi'
import Masuldorliknibosharish from './views/masuldorlikni-bosharish'
import Ishgazhoylashishzharaeni from './views/ishga-zhoylashish-zharaeni'
import Biometrikfotosura from './views/biometrik-fotosura'
import Faq from './views/faq'

import Hengenvizasi from './views/hengen-vizasi'
import Shengenvizasi from './views/shengen-vizasi'

import Ishtaminotibyichasrovnoma from './views/ish-taminoti-byicha-srovnoma'
import Uzbekistangermanyuz from './views/uzbekistan-germanyuz'
import Uzbekistanczechrepublic from './views/uzbekistan-czech-republic'
import Tajikistangermanyuz from './views/tajikistan-germanyuz'
import Tajikistanczechrepublic from './views/tajikistan-czech-republic'
import Uchrashuvsanasinivavatinibelgilash from './views/uchrashuv-sanasini-va-vatini-belgilash'
import Tlovshartlari from './views/tlov-shartlari'
import Khuzhzhatlartarzhimasi from './views/khuzhzhatlar-tarzhimasi'
import Biometrikmalumotlarini from './views/biometrik-malumotlarini'
import Ilovanikuzatish from './views/ilovani-kuzatish'
import Arizatopshirishdansnggiolat from './views/ariza-topshirishdan-snggi-olat'
import Primetime from './views/prime-time'
import Arizashakllari from './views/ariza-shakllari'
import Kurerlikkhizmatioralietkazibberish from './views/kurerlik-khizmati-orali-etkazib-berish'
import Fotonuskhafakschopetishkhizmatlari from './views/foto-nuskha-faks-chop-etish-khizmatlari'
import Foydaliavolalaruz from './views/foydali-avolalar-uz'
import Khabardorilishkhizmati from './views/khabardor-ilish-khizmati'
import Arizaoldin from './views/ariza-oldin'
import Rasmiybayramlarkuni from './views/rasmiy-bayramlar-kuni'
import Khalarotibbiysuurta from './views/khalaro-tibbiy-suurta'
import Tekhnikakhavfsizligikrsatmalari from './views/tekhnika-khavfsizligi-krsatmalari'
import Umumiymalumot from './views/umumiy-malumot'
import Milliyviza from './views/milliy-viza'
import Talimvamalakaoshirish from './views/talim-va-malaka-oshirish'
import Contactform from './views/contact-form'
import Khodimlarbulimikonunkoidalari from './views/khodimlar-bulimi-konun-koidalari'
import NotFound from './views/not-found'



// ======================= App =======================
const App = () => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://static.elfsight.com/platform/platform.js'
    script.async = true
    document.body.appendChild(script)
  }, [])

  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />

        <Route exact path="/uzhzhatlar" component={Uzhzhatlar} />
        <Route exact path="/arizalarni-krib-chiish-muddati" component={Arizalarnikribchiishmuddati} />
        <Route exact path="/submission-collection" component={Submissioncollection} />

        <Route exact path="/kyrgyzstan-germanyuz" component={KyrgyzstanGermanyUz} />
        <Route exact path="/kyrgyzstan-chex" component={KyrgyzstanCzech} />

        <Route exact path="/uzbekistan-germanyuz" component={Uzbekistangermanyuz} />
        <Route exact path="/uzbekistan-czech-republic" component={Uzbekistanczechrepublic} />

        <Route exact path="/tajikistan-germanyuz" component={Tajikistangermanyuz} />
        <Route exact path="/tajikistan-czech-republic" component={Tajikistanczechrepublic} />

        <Route exact path="/hengen-vizasi" component={Hengenvizasi} />
        <Route exact path="/shengen-vizasi" component={Shengenvizasi} />


        <Route component={NotFound} />
      </Switch>

      <div
        className="elfsight-app-5b7bb311-5565-427e-b3c0-d5e8f1dcb7ae"
        data-elfsight-app-lazy
      />
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
